module.exports = __webpack_public_path__ + "img/screenshot-1.4dd6f579.png";